import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {} = {
  appConfig: {
    modules: [],
    theme: "amps",
  },
  config_values: [],
  isWatermark: false,
  error: false,
  loading: false,
  documentId: "amps",
  impersonate: false,
  impersonateErrorMessage: "",
};
const appConfigReducer = (state = initialState, action) => {
  console.log(action);
  switch (action.type) {
    case actionTypes.FETCH_APP_CONFIG_SUCCESS: {
      return updateObject(state, {
        appConfig: action.appConfig,
        config_values: action.config_values,
        error: false,
        loading: false,
        isWatermark: action.isWatermark,
      });
    }
    case actionTypes.CAN_USER_IMPERSONATE_SUCCESS: {
      return updateObject(state, {
        impersonate: action.value,
      });
    }
    case actionTypes.CAN_USER_IMPERSONATE_FAILED: {
      return updateObject(state, {
        impersonate: false,
      });
    }
    case actionTypes.IMPERSONATED_USER_TOKEN_FAILED: {
      return updateObject(state, {
        error: true,
        impersonateErrorMessage: action.payload,
      });
    }
    case actionTypes.FETCH_APP_CONFIG_FAILED: {
      return {
        ...state,
        error: true,
        loading: false,
      };
    }
    case actionTypes.FETCH_APP_CONFIG_STARTED: {
      return {
        ...state,
        error: false,
        loading: true,
      };
    }
    default:
      return state;
  }
};
export default appConfigReducer;
